import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  GetRunningControlPanelResultType,
  RestartModuleDataType,
  StartModuleDataType,
} from 'src/app/services/control-panel/control-panel.service.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const controlPanelSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getModulesAndMachines: builder.query<GetRunningControlPanelResultType, { name: string }>({
      query: () => ({
        url: finalUrlsConfig().controlPanel.running,
      }),
      providesTags: [{ type: 'ControlPanel', id: 'LIST' }],
    }),
    restartModule: builder.mutation<void, RestartModuleDataType>({
      query: (data) => ({
        url: finalUrlsConfig().controlPanel.restart,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (_result, _error) => [{ type: 'ControlPanel', id: 'LIST' }],
    }),
    getModulesByMachine: builder.query<string[], { machineIp: string }>({
      query: (params) => ({
        url: finalUrlsConfig().controlPanel.getModulesByMachine,
        params,
      }),
    }),
    startModule: builder.mutation<string, StartModuleDataType>({
      query: (data) => ({
        url: finalUrlsConfig().controlPanel.start,
        body: data,
        method: 'POST',
        responseHandler: 'text',
      }),
    }),
  }),
});

export const {
  useStartModuleMutation,
  useGetModulesByMachineQuery,
  useGetModulesAndMachinesQuery,
  useRestartModuleMutation,
} = controlPanelSlice;
